var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeasing = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "0 0 80 80"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1F1FF",
  d: "M69.16 57.107a32 32 0 1 0-58.32 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.8 57.107h62.4M5.2 57.107h2M72.8 57.107h2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M14.086 66.099c0 .276.693.549 2.039.804s3.32.487 5.807.682 5.44.35 8.69.456 6.733.16 10.251.16 7.001-.054 10.251-.16a194 194 0 0 0 8.69-.456c2.488-.195 4.461-.427 5.807-.682s2.04-.528 2.04-.805c0-.276-.694-.549-2.04-.804s-3.319-.487-5.806-.682a194 194 0 0 0-8.69-.456c-3.25-.106-6.734-.16-10.252-.16s-7 .054-10.25.16-6.204.26-8.691.456c-2.488.195-4.46.427-5.807.682-1.346.255-2.04.528-2.04.805"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M18.297 64.027a.93.93 0 0 0 .926.926h25.008V9.455a.93.93 0 0 0-.926-.925h-24.08a.93.93 0 0 0-.927.925z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M18.297 64.027a.93.93 0 0 0 .926.926h25.008V9.455a.93.93 0 0 0-.926-.925h-24.08a.93.93 0 0 0-.927.925z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.233 64.953h17.44a.93.93 0 0 0 .926-.926V24.764a.93.93 0 0 0-.928-.924H44.23z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M44.233 64.953h17.44a.93.93 0 0 0 .926-.926V24.764a.93.93 0 0 0-.928-.924H44.23z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M48.402 16.584h2.005a.61.61 0 0 1 .61.609v6.647h-3.224v-6.647a.61.61 0 0 1 .609-.609M21.324 3.693h2.005a.61.61 0 0 1 .61.61V8.53h-3.224V4.303a.61.61 0 0 1 .61-.61M51.309 31.904h6.448v24.182H51.31z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M44.23 31.906h20.173a.61.61 0 0 0 .61-.61v-2.005a.61.61 0 0 0-.61-.61H44.23zM44.23 39.966h20.173a.61.61 0 0 0 .61-.61v-2.005a.61.61 0 0 0-.61-.609H44.23zM44.23 48.027h20.173a.61.61 0 0 0 .61-.61v-2.005a.61.61 0 0 0-.61-.611H44.23zM44.23 56.087h20.173a.61.61 0 0 0 .61-.61v-2.004a.61.61 0 0 0-.61-.61H44.23zM44.23 64.952h15.14v-4.167a.93.93 0 0 0-.926-.926H44.23z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M24.781 8.53v56.423M31.266 8.53v56.423M37.746 8.53v56.423M18.297 16.485H44.23M18.297 24.44H44.23M18.297 32.395H44.23M18.297 40.351H44.23M18.297 48.306H44.23M18.297 56.262H44.23"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M72.55 57.544a2.54 2.54 0 0 0-.277-4.27 1.695 1.695 0 1 0-2.457 0 2.54 2.54 0 0 0-.277 4.27 3.388 3.388 0 1 0 3.01 0"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M71.047 63.996v4.205"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M13.525 51.475a2.54 2.54 0 0 0-.276-4.27 1.694 1.694 0 1 0-2.458 0 2.54 2.54 0 0 0-.276 4.27 3.387 3.387 0 1 0 3.01 0"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.02 57.928v4.204"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M34.027 58.606a3.377 3.377 0 0 0-.367-5.677 2.251 2.251 0 1 0-3.266 0 3.377 3.377 0 0 0-.367 5.676 4.504 4.504 0 1 0 4 0z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M32.027 67.182v5.588"
})));
export { SvgLeasing as ReactComponent };